import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, List, ListItem, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { SideBarType } from '@uplift/types';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';

import { NavigationItem } from './navigation-item.component';
import { useStyles } from './side-bar.styles';


const ObservedSidebar: React.FC<SideBarType> = observer(
  ({ mainNavConfig, infoNavConfig, toggleSideBar }) => {
    const l10n = useL10n();
    const { classes } = useStyles();

    return (
      <Box className={classes.sidebar}>
        <Box className={classes.wrapper}>
          <List className={classes.list}>
            {mainNavConfig?.map((item) => (
              <NavigationItem
                key={item.to}
                exact={item.exact ?? true}
                to={item.to}
                text={item.name}
                icon={item.icon}
                disabled={item.disabled}
                restricted={item.restricted}
                activeIcon={item.activeIcon}
                activeClassName={classes.activeNav}
                toggleSideBar={toggleSideBar}
                onDisabledClick={item.onDisabledClick}
              />
            ))}
          </List>

          {infoNavConfig && (
            <>
              <List className={classes.list}>
                <ListItem className={classes.listItem}>
                  <div className={classes.tools}>{l10n.general.tools}</div>
                </ListItem>
              </List>

              <List className={classes.list}>
                {infoNavConfig.map((item) => {
                  if (item.to === '') {
                    return <span key={item.to} />;
                  } else {
                    return (
                      <NavigationItem
                        key={item.to}
                        exact={item.exact ?? true}
                        to={item.to}
                        text={item.name}
                        icon={item.icon}
                        activeClassName={classes.activeNav}
                        toggleSideBar={toggleSideBar}
                      />
                    );
                  }
                })}
              </List>
            </>
          )}
        </Box>
        <Box height="100%" />
        <Box className={classes.contactSupportContainer}>
          <a
            className={classes.contactSupportLink}
            href="https://client-help.joinuplift.co/"
            target="_blank"
            rel="noreferrer"
          >
            <ContactSupportOutlinedIcon
              className={classes.contactSupportIcon}
            />
            <Typography className={classes.contactSupportText}>
              {l10n.general.helpCenter}
            </Typography>
          </a>
        </Box>

        <Box className={classes.privacy}>
          <a
            href="https://www.joinuplift.co/tos"
            rel="noreferrer"
            target="_blank"
          >
            {l10n.general.terms}
          </a>
          <p className={classes.dot}>•</p>
          <a
            href="https://www.joinuplift.co/privacy"
            rel="noreferrer"
            target="_blank"
          >
            {l10n.general.privacy}
          </a>
        </Box>
      </Box>
    );
  }
);

export const SideBar = ({
  infoNavConfig,
  mainNavConfig,
  toggleSideBar,
}: SideBarType) => {
  return (
    <ObservedSidebar
      infoNavConfig={infoNavConfig}
      mainNavConfig={mainNavConfig}
      toggleSideBar={toggleSideBar}
    />
  );
};
